(() => {
  if (window.__videoPopupInitialized) return;
  window.__videoPopupInitialized = true;

  function openVideoPopup(popupId, videoUrl) {
    const popup = document.getElementById(popupId);
    if (!popup) return;

    const iframe = popup.querySelector('.video-popup__iframe');
    if (!iframe) return;

    const embedUrl = getEmbedUrl(videoUrl);
    if (!embedUrl) {
      console.warn('Unsupported video URL for popup:', videoUrl);
      return;
    }

    iframe.src = embedUrl;
    popup.hidden = false;
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('video-popup--open');

    const focusable = popup.querySelector('[data-video-popup-close]');
    if (focusable) focusable.focus();
  }

  function closeVideoPopup(popup) {
    if (!popup) return;
    const iframe = popup.querySelector('.video-popup__iframe');
    if (iframe) {
      iframe.src = '';
    }
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    popup.hidden = true;
    document.body.classList.remove('video-popup--open');
  }

  function getEmbedUrl(url) {
    if (!url) return '';
    try {
      const parsedUrl = new URL(url, window.location.origin);
      const hostname = parsedUrl.hostname.replace(/^www\./, '').toLowerCase();

      if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
        if (parsedUrl.pathname.startsWith('/embed/')) {
          parsedUrl.searchParams.set('autoplay', '1');
          parsedUrl.searchParams.set('rel', '0');
          return parsedUrl.toString();
        }

        if (parsedUrl.pathname === '/watch') {
          const videoId = parsedUrl.searchParams.get('v');
          if (videoId) {
            return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
          }
        }

        const shortsMatch = parsedUrl.pathname.match(/^\/shorts\/([^/]+)/);
        if (shortsMatch) {
          return `https://www.youtube.com/embed/${shortsMatch[1]}?autoplay=1&rel=0`;
        }
      }

      if (hostname === 'youtu.be') {
        const videoId = parsedUrl.pathname.replace('/', '');
        if (videoId) {
          return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        }
      }

      if (hostname === 'youtube-nocookie.com') {
        if (parsedUrl.pathname.startsWith('/embed/')) {
          parsedUrl.searchParams.set('autoplay', '1');
          parsedUrl.searchParams.set('rel', '0');
          return parsedUrl.toString();
        }
      }

      if (hostname === 'vimeo.com') {
        const videoId = parsedUrl.pathname.replace('/', '');
        if (videoId) {
          return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        }
      }

      if (hostname === 'player.vimeo.com') {
        parsedUrl.searchParams.set('autoplay', '1');
        return parsedUrl.toString();
      }

      return url;
    } catch (error) {
      console.warn('Failed to parse video URL for popup:', error);
      return url;
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-video-popup-trigger]');
    if (trigger) {
      event.preventDefault();
      const popupId = trigger.getAttribute('data-video-popup-trigger');
      const videoUrl = trigger.getAttribute('data-video-popup-url');
      if (popupId && videoUrl) {
        openVideoPopup(popupId, videoUrl);
      }
      return;
    }

    const closeBtn = event.target.closest('[data-video-popup-close]');
    if (closeBtn) {
      const popup = closeBtn.closest('.video-popup');
      closeVideoPopup(popup);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const popup = document.querySelector('.video-popup.is-visible');
    if (popup) {
      closeVideoPopup(popup);
    }
  });
})();

